import React, {useState, useEffect} from 'react';
import {CSVLink} from 'react-csv';
import {getFileMetaData} from '../../actions/pure/media';
import {DownloadFilesAsZip, encodeUrl, GetFileSize} from '../../utils/helper';
import {CommonSpinLoader} from '../../ui-components/loaders';
import {DownloadFileIcon, DownloadZipFileIcon} from '../../ui-components/Iconpack';
interface ImageCsvProps {
    fileUids: string[] | undefined;
    orgUid: string;
}

export default function ImageCsv({fileUids, orgUid}: ImageCsvProps) {
    const [csvData, setCsvData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [fileData, setFileData] = useState<any[]>([]);
    const downloadZip = () => {
        const imageUrls = fileData.map((meta) => encodeUrl(meta.cdn_url));
        const fileNames = fileData.map((meta) => `${meta.name}`);
        DownloadFilesAsZip(imageUrls, fileNames);
    };

    useEffect(() => {
        if (fileUids) {
            setLoading(true);
            Promise.all(fileUids.map((uid) => getFileMetaData({orgUid, fileUid: uid})))
                .then((results) => {
                    setFileData(results);
                    const csvData: any[] = [];

                    results.forEach((meta) => {
                        const fileRows = [
                            [
                                meta.name,
                                meta.cdn_url,
                                'Original',
                                meta.type,
                                GetFileSize(meta.file_size),
                                meta.width || '',
                                meta.height || '',
                                meta.caption?.text || '',
                            ],
                        ];

                        if (Object.keys(meta.saved_images).length) {
                            const keys = Object.keys(meta.saved_images);
                            keys.forEach((data) => {
                                fileRows.push([
                                    meta.name,
                                    meta.saved_images[data].url,
                                    'Transformed',
                                    meta.saved_images[data].type,
                                    GetFileSize(meta.saved_images[data].size),
                                    meta.saved_images[data].width || '',
                                    meta.saved_images[data].height || '',
                                    '',
                                ]);
                            });
                        }

                        csvData.push(...fileRows);
                    });

                    csvData.unshift([
                        'Name',
                        'Cdn Url',
                        'File Status',
                        'Type',
                        'File Size',
                        'Width',
                        'Height',
                        'Caption',
                    ]);
                    setCsvData(csvData);
                })
                .catch((error) => {
                    console.error('Error occurred:', error);
                })
                .finally(() => {
                    setLoading(false);
                });
        }
    }, [fileUids, orgUid]);

    return (
        <>
            {loading ? (
                <CommonSpinLoader size={'xsm'} />
            ) : (
                csvData.length > 0 && (
                    <div className='flex flex-col gap-5'>
                        <div className='flex items-center justify-center gap-2'>
                            <DownloadFileIcon />
                            <CSVLink data={csvData} filename={'image_data.csv'} className='font-[400] text-[#667085]'>
                                Download CSV
                            </CSVLink>
                        </div>
                        <div className='flex items-center justify-center gap-2'>
                            <DownloadZipFileIcon />
                            <span className='cursor-pointer font-[400] text-[#667085]' onClick={downloadZip}>
                                Download ZIP
                            </span>
                        </div>
                    </div>
                )
            )}
        </>
    );
}
